/**
 * State Hero Image Imports
 *
 * Static imports for all state hero images.
 * Webpack processes these at build time and resolves the correct URLs.
 *
 * This matches the pattern used by PSP pages (e.g., RvStorageContent.js)
 */

// Desktop images (50 states)
import AK_Desktop from 'assets/images/state-heroes/desktop/AK.webp';
import AL_Desktop from 'assets/images/state-heroes/desktop/AL.webp';
import AR_Desktop from 'assets/images/state-heroes/desktop/AR.webp';
import AZ_Desktop from 'assets/images/state-heroes/desktop/AZ.webp';
import CA_Desktop from 'assets/images/state-heroes/desktop/CA.webp';
import CO_Desktop from 'assets/images/state-heroes/desktop/CO.webp';
import CT_Desktop from 'assets/images/state-heroes/desktop/CT.webp';
import DE_Desktop from 'assets/images/state-heroes/desktop/DE.webp';
import FL_Desktop from 'assets/images/state-heroes/desktop/FL.webp';
import GA_Desktop from 'assets/images/state-heroes/desktop/GA.webp';
import HI_Desktop from 'assets/images/state-heroes/desktop/HI.webp';
import IA_Desktop from 'assets/images/state-heroes/desktop/IA.webp';
import ID_Desktop from 'assets/images/state-heroes/desktop/ID.webp';
import IL_Desktop from 'assets/images/state-heroes/desktop/IL.webp';
import IN_Desktop from 'assets/images/state-heroes/desktop/IN.webp';
import KS_Desktop from 'assets/images/state-heroes/desktop/KS.webp';
import KY_Desktop from 'assets/images/state-heroes/desktop/KY.webp';
import LA_Desktop from 'assets/images/state-heroes/desktop/LA.webp';
import MA_Desktop from 'assets/images/state-heroes/desktop/MA.webp';
import MD_Desktop from 'assets/images/state-heroes/desktop/MD.webp';
import ME_Desktop from 'assets/images/state-heroes/desktop/ME.webp';
import MI_Desktop from 'assets/images/state-heroes/desktop/MI.webp';
import MN_Desktop from 'assets/images/state-heroes/desktop/MN.webp';
import MO_Desktop from 'assets/images/state-heroes/desktop/MO.webp';
import MS_Desktop from 'assets/images/state-heroes/desktop/MS.webp';
import MT_Desktop from 'assets/images/state-heroes/desktop/MT.webp';
import NC_Desktop from 'assets/images/state-heroes/desktop/NC.webp';
import ND_Desktop from 'assets/images/state-heroes/desktop/ND.webp';
import NE_Desktop from 'assets/images/state-heroes/desktop/NE.webp';
import NH_Desktop from 'assets/images/state-heroes/desktop/NH.webp';
import NJ_Desktop from 'assets/images/state-heroes/desktop/NJ.webp';
import NM_Desktop from 'assets/images/state-heroes/desktop/NM.webp';
import NV_Desktop from 'assets/images/state-heroes/desktop/NV.webp';
import NY_Desktop from 'assets/images/state-heroes/desktop/NY.webp';
import OH_Desktop from 'assets/images/state-heroes/desktop/OH.webp';
import OK_Desktop from 'assets/images/state-heroes/desktop/OK.webp';
import OR_Desktop from 'assets/images/state-heroes/desktop/OR.webp';
import PA_Desktop from 'assets/images/state-heroes/desktop/PA.webp';
import RI_Desktop from 'assets/images/state-heroes/desktop/RI.webp';
import SC_Desktop from 'assets/images/state-heroes/desktop/SC.webp';
import SD_Desktop from 'assets/images/state-heroes/desktop/SD.webp';
import TN_Desktop from 'assets/images/state-heroes/desktop/TN.webp';
import TX_Desktop from 'assets/images/state-heroes/desktop/TX.webp';
import UT_Desktop from 'assets/images/state-heroes/desktop/UT.webp';
import VA_Desktop from 'assets/images/state-heroes/desktop/VA.webp';
import VT_Desktop from 'assets/images/state-heroes/desktop/VT.webp';
import WA_Desktop from 'assets/images/state-heroes/desktop/WA.webp';
import WI_Desktop from 'assets/images/state-heroes/desktop/WI.webp';
import WV_Desktop from 'assets/images/state-heroes/desktop/WV.webp';
import WY_Desktop from 'assets/images/state-heroes/desktop/WY.webp';

// Mobile images (50 states)
import AK_Mobile from 'assets/images/state-heroes/mobile/AK.webp';
import AL_Mobile from 'assets/images/state-heroes/mobile/AL.webp';
import AR_Mobile from 'assets/images/state-heroes/mobile/AR.webp';
import AZ_Mobile from 'assets/images/state-heroes/mobile/AZ.webp';
import CA_Mobile from 'assets/images/state-heroes/mobile/CA.webp';
import CO_Mobile from 'assets/images/state-heroes/mobile/CO.webp';
import CT_Mobile from 'assets/images/state-heroes/mobile/CT.webp';
import DE_Mobile from 'assets/images/state-heroes/mobile/DE.webp';
import FL_Mobile from 'assets/images/state-heroes/mobile/FL.webp';
import GA_Mobile from 'assets/images/state-heroes/mobile/GA.webp';
import HI_Mobile from 'assets/images/state-heroes/mobile/HI.webp';
import IA_Mobile from 'assets/images/state-heroes/mobile/IA.webp';
import ID_Mobile from 'assets/images/state-heroes/mobile/ID.webp';
import IL_Mobile from 'assets/images/state-heroes/mobile/IL.webp';
import IN_Mobile from 'assets/images/state-heroes/mobile/IN.webp';
import KS_Mobile from 'assets/images/state-heroes/mobile/KS.webp';
import KY_Mobile from 'assets/images/state-heroes/mobile/KY.webp';
import LA_Mobile from 'assets/images/state-heroes/mobile/LA.webp';
import MA_Mobile from 'assets/images/state-heroes/mobile/MA.webp';
import MD_Mobile from 'assets/images/state-heroes/mobile/MD.webp';
import ME_Mobile from 'assets/images/state-heroes/mobile/ME.webp';
import MI_Mobile from 'assets/images/state-heroes/mobile/MI.webp';
import MN_Mobile from 'assets/images/state-heroes/mobile/MN.webp';
import MO_Mobile from 'assets/images/state-heroes/mobile/MO.webp';
import MS_Mobile from 'assets/images/state-heroes/mobile/MS.webp';
import MT_Mobile from 'assets/images/state-heroes/mobile/MT.webp';
import NC_Mobile from 'assets/images/state-heroes/mobile/NC.webp';
import ND_Mobile from 'assets/images/state-heroes/mobile/ND.webp';
import NE_Mobile from 'assets/images/state-heroes/mobile/NE.webp';
import NH_Mobile from 'assets/images/state-heroes/mobile/NH.webp';
import NJ_Mobile from 'assets/images/state-heroes/mobile/NJ.webp';
import NM_Mobile from 'assets/images/state-heroes/mobile/NM.webp';
import NV_Mobile from 'assets/images/state-heroes/mobile/NV.webp';
import NY_Mobile from 'assets/images/state-heroes/mobile/NY.webp';
import OH_Mobile from 'assets/images/state-heroes/mobile/OH.webp';
import OK_Mobile from 'assets/images/state-heroes/mobile/OK.webp';
import OR_Mobile from 'assets/images/state-heroes/mobile/OR.webp';
import PA_Mobile from 'assets/images/state-heroes/mobile/PA.webp';
import RI_Mobile from 'assets/images/state-heroes/mobile/RI.webp';
import SC_Mobile from 'assets/images/state-heroes/mobile/SC.webp';
import SD_Mobile from 'assets/images/state-heroes/mobile/SD.webp';
import TN_Mobile from 'assets/images/state-heroes/mobile/TN.webp';
import TX_Mobile from 'assets/images/state-heroes/mobile/TX.webp';
import UT_Mobile from 'assets/images/state-heroes/mobile/UT.webp';
import VA_Mobile from 'assets/images/state-heroes/mobile/VA.webp';
import VT_Mobile from 'assets/images/state-heroes/mobile/VT.webp';
import WA_Mobile from 'assets/images/state-heroes/mobile/WA.webp';
import WI_Mobile from 'assets/images/state-heroes/mobile/WI.webp';
import WV_Mobile from 'assets/images/state-heroes/mobile/WV.webp';
import WY_Mobile from 'assets/images/state-heroes/mobile/WY.webp';

/**
 * Map of state codes to webpack-resolved image URLs
 * These URLs are resolved by webpack at build time (e.g., '/static/images/...')
 */
const STATE_HERO_IMAGES = {
	AK: { desktop: AK_Desktop, mobile: AK_Mobile },
	AL: { desktop: AL_Desktop, mobile: AL_Mobile },
	AR: { desktop: AR_Desktop, mobile: AR_Mobile },
	AZ: { desktop: AZ_Desktop, mobile: AZ_Mobile },
	CA: { desktop: CA_Desktop, mobile: CA_Mobile },
	CO: { desktop: CO_Desktop, mobile: CO_Mobile },
	CT: { desktop: CT_Desktop, mobile: CT_Mobile },
	DE: { desktop: DE_Desktop, mobile: DE_Mobile },
	FL: { desktop: FL_Desktop, mobile: FL_Mobile },
	GA: { desktop: GA_Desktop, mobile: GA_Mobile },
	HI: { desktop: HI_Desktop, mobile: HI_Mobile },
	IA: { desktop: IA_Desktop, mobile: IA_Mobile },
	ID: { desktop: ID_Desktop, mobile: ID_Mobile },
	IL: { desktop: IL_Desktop, mobile: IL_Mobile },
	IN: { desktop: IN_Desktop, mobile: IN_Mobile },
	KS: { desktop: KS_Desktop, mobile: KS_Mobile },
	KY: { desktop: KY_Desktop, mobile: KY_Mobile },
	LA: { desktop: LA_Desktop, mobile: LA_Mobile },
	MA: { desktop: MA_Desktop, mobile: MA_Mobile },
	MD: { desktop: MD_Desktop, mobile: MD_Mobile },
	ME: { desktop: ME_Desktop, mobile: ME_Mobile },
	MI: { desktop: MI_Desktop, mobile: MI_Mobile },
	MN: { desktop: MN_Desktop, mobile: MN_Mobile },
	MO: { desktop: MO_Desktop, mobile: MO_Mobile },
	MS: { desktop: MS_Desktop, mobile: MS_Mobile },
	MT: { desktop: MT_Desktop, mobile: MT_Mobile },
	NC: { desktop: NC_Desktop, mobile: NC_Mobile },
	ND: { desktop: ND_Desktop, mobile: ND_Mobile },
	NE: { desktop: NE_Desktop, mobile: NE_Mobile },
	NH: { desktop: NH_Desktop, mobile: NH_Mobile },
	NJ: { desktop: NJ_Desktop, mobile: NJ_Mobile },
	NM: { desktop: NM_Desktop, mobile: NM_Mobile },
	NV: { desktop: NV_Desktop, mobile: NV_Mobile },
	NY: { desktop: NY_Desktop, mobile: NY_Mobile },
	OH: { desktop: OH_Desktop, mobile: OH_Mobile },
	OK: { desktop: OK_Desktop, mobile: OK_Mobile },
	OR: { desktop: OR_Desktop, mobile: OR_Mobile },
	PA: { desktop: PA_Desktop, mobile: PA_Mobile },
	RI: { desktop: RI_Desktop, mobile: RI_Mobile },
	SC: { desktop: SC_Desktop, mobile: SC_Mobile },
	SD: { desktop: SD_Desktop, mobile: SD_Mobile },
	TN: { desktop: TN_Desktop, mobile: TN_Mobile },
	TX: { desktop: TX_Desktop, mobile: TX_Mobile },
	UT: { desktop: UT_Desktop, mobile: UT_Mobile },
	VA: { desktop: VA_Desktop, mobile: VA_Mobile },
	VT: { desktop: VT_Desktop, mobile: VT_Mobile },
	WA: { desktop: WA_Desktop, mobile: WA_Mobile },
	WI: { desktop: WI_Desktop, mobile: WI_Mobile },
	WV: { desktop: WV_Desktop, mobile: WV_Mobile },
	WY: { desktop: WY_Desktop, mobile: WY_Mobile },
};

export default STATE_HERO_IMAGES;
